import type { TimeRange } from 'generated/graphql'
import { TimeUnit } from 'generated/graphql'

type TTimeUnit = 'hour' | 'day' | 'week' | 'month' | 'year'

export const getTimeUnit = (timeUnit: TTimeUnit): TimeUnit => {
  if (timeUnit === 'hour') return TimeUnit.Hour
  if (timeUnit === 'day') return TimeUnit.Day
  if (timeUnit === 'week') return TimeUnit.Week
  if (timeUnit === 'month') return TimeUnit.Month
  if (timeUnit === 'year') return TimeUnit.Year
}

export const getTimeRange = (timeUnit: TTimeUnit, timeValue: number): TimeRange => {
  return { timeUnit: getTimeUnit(timeUnit), timeValue }
}
